import { useCallback, useEffect, useState } from "react";
import { DEFAULT_ITEMS, MenuItem } from "./items";
import { checkDisability } from "utils/permissionHelper";
import { isPermissionEnabled } from "utils/permissionHelper";
import { hasPermission } from "utils/permissionHelper";
import { permissionConstants } from "utils/permissionHelper";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useFeatures } from "hooks/useFeatures";

export type SidebarItems = {
  lender: MenuItem[];
  borrower: MenuItem[];
};

export function useSidebarItems() {
  const { user } = useTenant();
  const { hasFeature } = useFeatures();
  const [items, setItems] = useState<SidebarItems>(DEFAULT_ITEMS);
  const [loaded, setLoaded] = useState(false);

  const checkPermissions = useCallback(() => {
    let filteredLender = items?.lender ?? [];

    if (!hasPermission(user, permissionConstants.viewAnalytics) && isPermissionEnabled(user)) {
      filteredLender = filteredLender.filter((menu: any) => menu.label !== "Analytics");
      setItems(prevItem => {
        return {
          ...prevItem,
          lender: filteredLender.map(menu => ({
            ...menu,
            subItems: menu.subItems?.filter(item => item.label !== "Revenue"),
          })),
        };
      });
    }

    if (checkDisability(user, "disable_properties")) {
      filteredLender = filteredLender.filter((menu: any) => menu.label !== "Properties");
      setItems(prevItem => {
        return {
          ...prevItem,
          lender: filteredLender,
          borrower: filteredLender,
        };
      });
    }

    if (checkDisability(user, "disable_documents") && user.type === "borrower") {
      filteredLender = filteredLender.filter((menu: any) => menu.label !== "Documents");
      setItems(prevItem => {
        return {
          ...prevItem,
          lender: filteredLender,
          borrower: filteredLender,
        };
      });
    }

    if (!hasFeature("analytics_revenue")) {
      ///remove revenue sub item from analytics
      const analytics = filteredLender.find(item => item.label === "Analytics");
      if (analytics) {
        analytics.subItems = analytics.subItems?.filter(item => item.label !== "Revenue");
        setItems(prevItem => {
          return {
            ...prevItem,
            lender: filteredLender,
          };
        });
      }
    }

    if (!hasFeature("transactions")) {
      setItems(prevItem => {
        return {
          ...prevItem,
          lender: filteredLender.filter(item => item.label !== "Transactions"),
        };
      });
    }
  }, [items, user, hasFeature]);

  useEffect(() => {
    if (!loaded) {
      checkPermissions();
      setLoaded(true);
    }
  }, [checkPermissions, loaded]);

  return { items, loaded };
}
